import styles from './NotFoundPage.module.scss';

/**
 * 404 page shown when no route matches the current URL.
 */
export function NotFoundPage() {
  const handleGoHome = () => {
    window.location.href = '/promote';
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.code}>404</h1>
        <h2 className={styles.title}>Page not found</h2>
        <p className={styles.description}>
          The page you are looking for does not exist or has been moved.
        </p>
        <button className={styles.button} onClick={handleGoHome} type="button">
          Go to Dashboard
        </button>
      </div>
    </div>
  );
}
